import { Flex } from 'antd'
import React from 'react'

const ScoreCard = ({ icon, color, type, score, maturity }) => {
  return (
    <>
      <Flex vertical={true} style={{ width: '50%' }}>
        <Flex vertical={true} gap={15} style={{
          backgroundColor: '#FFF',
          padding: 25,
          borderRadius: 10,
          zIndex: 1
        }}>
          <Flex justify='center' align='center' style={{
            width: '67px',
            height: '61px',
            borderRadius: '10px',
            border: `2px solid ${color}`
          }}>
            {icon}
          </Flex>
          <Flex justify='space-between' style={{ fontSize: 16, lineHeight: '26px' }}>
            <Flex vertical={true}>
              <div style={{ color: '#07224D' }}>{type === 'domain' ? 'Domain' : (type === 'dimension' ? 'Dimension' : null)} Score:</div>
              <div style={{ color: '#92A7BE' }}>{score ? score : '-'}</div>
            </Flex>
            <Flex vertical={true}>
              <div style={{ color: '#07224D' }}>Maturity:</div>
              <div style={{ color: '#92A7BE' }}>{maturity ? maturity : '-'}</div>
            </Flex>
          </Flex>
        </Flex>
        <div style={{ height: 25, marginTop: '-15px', borderRadius: '0 0 10px 10px', backgroundColor: color, }}></div>
      </Flex>
    </>
  )
}

export default ScoreCard